import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export type ActionMenuItemTone = 'default' | 'danger';

export interface ActionMenuItem {
  id: string;
  label: string;
  tone?: ActionMenuItemTone;
}

@Component({
  selector: 'app-action-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './action-menu.html',
})
export class ActionMenuComponent {
  @Input() isOpen = false;
  @Input() items: ActionMenuItem[] = [];

  @Output() itemSelected = new EventEmitter<ActionMenuItem>();

  protected selectItem(item: ActionMenuItem): void {
    this.itemSelected.emit(item);
  }
}
